export const ROUTES_NAME = {
  WELCOME: "welcome",
  CREATE_PROFILE_ADMIN: "create_profile_admin",
  CREATE_WITH_IMPORT: "create_with_import",
  ENTRY_MEMBER: "entry_member",
  GIFT_RESULT: "GIFT_RESULT",
  CREATE_PIN_ADMIN: "create_admin_pin",
  HOME: "home",
};
